import { onMounted, onUnmounted, ref } from 'vue'
import {
  ASSISTANT_FAB_INTRO_DURATION_MS,
  ASSISTANT_FAB_INTRO_STORAGE_KEY,
  ASSISTANT_FAB_SHRINK_ANIMATION_MS,
} from './assistant-theme'

const SHRINK_FALLBACK_BUFFER_MS = 50

export function isAssistantFabIntroDone (): boolean {
  return sessionStorage.getItem(ASSISTANT_FAB_INTRO_STORAGE_KEY) === '1'
}

export function markAssistantFabIntroDone (): void {
  sessionStorage.setItem(ASSISTANT_FAB_INTRO_STORAGE_KEY, '1')
}

export function clearAssistantFabIntroDone (): void {
  sessionStorage.removeItem(ASSISTANT_FAB_INTRO_STORAGE_KEY)
}

export function useAssistantFabIntro () {
  const isExpanded = ref(!isAssistantFabIntroDone())
  const isShrinking = ref(false)

  let shrinkTimer: ReturnType<typeof setTimeout> | null = null
  let collapseFallbackTimer: ReturnType<typeof setTimeout> | null = null

  const clearCollapseFallbackTimer = (): void => {
    if (collapseFallbackTimer) {
      clearTimeout(collapseFallbackTimer)
      collapseFallbackTimer = null
    }
  }

  const completeShrink = (): void => {
    if (!isShrinking.value) {
      return
    }

    clearCollapseFallbackTimer()
    isExpanded.value = false
    isShrinking.value = false
    markAssistantFabIntroDone()
  }

  const startShrinkFallback = (): void => {
    clearCollapseFallbackTimer()
    collapseFallbackTimer = setTimeout(() => {
      completeShrink()
    }, ASSISTANT_FAB_SHRINK_ANIMATION_MS + SHRINK_FALLBACK_BUFFER_MS)
  }

  onMounted(() => {
    if (!isExpanded.value) {
      return
    }

    shrinkTimer = setTimeout(() => {
      isShrinking.value = true
      startShrinkFallback()
    }, ASSISTANT_FAB_INTRO_DURATION_MS)
  })

  onUnmounted(() => {
    if (shrinkTimer) {
      clearTimeout(shrinkTimer)
    }

    clearCollapseFallbackTimer()
  })

  return {
    isExpanded,
    isShrinking,
    completeShrink,
  }
}
